import Reveal from "@/components/feature/Reveal";
import Logo from "@/components/feature/Logo";

export default function AboutSection() {
  return (
    <section id="about" className="bg-background-50 py-20 md:py-28">
      <div className="mx-auto max-w-4xl px-4 md:px-6">
        <Reveal className="text-center">
          <p className="font-label text-[36px] font-bold tracking-[0.15em] text-foreground-700 md:text-[40px]">
            ABOUT US
          </p>
          <h2 className="mt-4 font-heading text-3xl font-black leading-tight text-foreground-950 md:text-5xl">
            Strategy × Technology × Human
          </h2>
          <p className="mx-auto mt-6 max-w-2xl font-body text-sm leading-relaxed text-foreground-600 md:text-base">
            株式会社ナンバは、テクノロジーの力で「人」と「組織」を深く見つめ、
            データに基づく戦略で、その先の未来をつくる会社です。
          </p>
        </Reveal>

        <Reveal delay={140} className="mt-16 md:mt-20">
          <div className="flex justify-center">
            <div className="-translate-x-2 h-px w-16 translate-y-1 bg-background-300" />
          </div>
          <div className="mt-12 space-y-6 text-center md:mt-16 md:space-y-7">
            <p className="font-heading text-3xl font-bold leading-tight tracking-tight text-foreground-800 md:text-4xl">
              人を見る。
            </p>
            <p className="font-heading text-3xl font-bold leading-tight tracking-tight text-foreground-800 md:text-4xl">
              組織を見る。
            </p>
            <p className="pt-2 font-heading text-3xl font-black leading-tight tracking-tight md:text-4xl">
              <span className="text-foreground-400">そして、</span>
              <span className="bg-gradient-to-r from-primary-500 to-accent-500 bg-clip-text text-transparent">
                未来をつくる。
              </span>
            </p>
            <Logo
              className="mx-auto h-10 md:h-12"
              src="/images/namba/logo.png"
            />
          </div>
        </Reveal>
      </div>
    </section>
  );
}